import styled from 'styled-components';
import useSWR from 'swr';
import { useTranslations } from 'next-intl';

import BrandGrid from '@/components/brand-grid';
import Section from '@/components/section';
import config from '@/config';

const Container = styled.div`
  margin: 0 auto;
  max-width: ${props => props.theme.maxContentWidth};
  margin-bottom: 2em;

  h2 {
    margin-bottom: 1.5em;
    text-align: center;
  }
`;

const fetcher = (...args) => fetch(...args).then(res => res.json()).then(result => result.groups.length > 0 ? result.groups[0].categories[0].brands.slice(0, 13) : []);

const OtherBrandsInCountry = ({ brand: { country, id: currentBrandId } }) => {
  const t = useTranslations('otherBrandsInCountry');
  const apiUrl = `${config.commerceApiUrl}/search?countryId=${country.id}&type=giftcard&minimal=true`;
  const { data } = useSWR(apiUrl, fetcher, {});
  let brandsToShow;

  if (data) {
    brandsToShow = data.filter(b => b.id !== currentBrandId).slice(0, 12);
  }

  if (!brandsToShow || !brandsToShow.length) {
    return null;
  }

  return (
    <Section>
      <Container>
        <h2>{t('title', { country: country.name })}</h2>
        {brandsToShow && <BrandGrid brands={brandsToShow} />}
      </Container>
    </Section>
  );
};

export default OtherBrandsInCountry;
